export default "icons/filter.svg"